export default __webpack_public_path__ + "static/media/my_journey_part2_8.0520cfd4.png";